import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";

const INIT_STATE = {
  loadingLocations: false,
  loadingAllLocations: false,
  totalLocations: 0,
  locations: [],
  error: null,
  allLocations: []
};

const route = "modules/manage/views/main/components/locationsTab/redux/slice.";

const manageSearchLocations = createAsyncThunk(
  "manage/locationsTab/manageSearchLocations",
  async ({ conditions = [], sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchLocations.query,
        {
          conditions,
          sort,
          limit,
          offset
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchLocations");
      return rejectWithValue(exc);
    }
  }
);

manageSearchLocations.query = `
     query ($conditions: [LocationSearchInput], $sort: [LocationSortInput], $limit: Int, $offset: Int) {
        data: searchLocations (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
            items {
                id
                title
                unitsCount
                enabledELDRule
                address {
                      address
                      city
                      formatted
                      state
                      zip
                }
                latitude
                longitude
                timezone
            }
            total
        }
    }
`;

const manageSearchAllLocations = createAsyncThunk(
  "manage/locationsTab/manageSearchAllLocations",
  async ({ sort = { field: "title", order: "ASC" } }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchLocations.query,
        {
          sort
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchAllLocations");
      return rejectWithValue(exc);
    }
  }
);

export { manageSearchLocations, manageSearchAllLocations };

//Slice
const manageLocationsRedux = createSlice({
  name: "manage/locationsTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchLocations
    builder.addCase(manageSearchLocations.pending, (state) => {
      state.loadingLocations = true;
    });
    builder.addCase(manageSearchLocations.fulfilled, (state, action) => {
      state.loadingLocations = false;
      state.locations = action.payload.items;
      state.totalLocations = action.payload.total;
    });
    builder.addCase(manageSearchLocations.rejected, (state, action) => {
      state.loadingLocations = false;
      state.error = action.payload;
    });
    //manageSearchAllLocations
    builder.addCase(manageSearchAllLocations.pending, (state) => {
      state.loadingAllLocations = true;
    });
    builder.addCase(manageSearchAllLocations.fulfilled, (state, action) => {
      state.loadingAllLocations = false;
      state.allLocations = action.payload.items;
    });
    builder.addCase(manageSearchAllLocations.rejected, (state, action) => {
      state.loadingAllLocations = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageLocationsRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
